import React from 'react';

interface IPOIIconProps {
	size?: string;
}

export const POIIcon = ({ size = '24' }: IPOIIconProps) => {
	return (
		<svg aria-hidden="true" width={size} height={size} viewBox="0 0 24 24" fill="none">
			<path
				d="M11.9166 2C7.54663 2.005 4.005 5.54663 4 9.91658C4 15.3332 9.41661 20.3331 11.0833 21.7081C11.5458 22.0973 12.2207 22.0973 12.6832 21.7081C14.4166 20.3331 19.8332 15.3332 19.8332 9.91658C19.8282 5.54663 16.2865 2.005 11.9166 2Z"
				stroke="#3D3D3D"
				strokeWidth="2"
			/>
			<circle cx="11.9186" cy="10.115" r="2.85711" stroke="#3D3D3D" strokeWidth="2" />
		</svg>
	);
};
